import { z } from 'zod'

export const INVOICE_STATUSES = ['Outstanding', 'Overdue', 'Paid', 'Cancelled'] as const
export const InvoiceStatusEnum = z.enum(INVOICE_STATUSES)

export type InvoiceStatusType = z.infer<typeof InvoiceStatusEnum>
